'use strict';

var React = require('react');

var SvgFlipCameraMajor = function SvgFlipCameraMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9.47 6.22a.75.75 0 0 1 1.06 0l1.5 1.5a.75.75 0 0 1 0 1.06l-1.5 1.5a.75.75 0 1 1-1.06-1.06l.185-.186a1.75 1.75 0 0 0 .345 3.466h.294c.804 0 1.456-.652 1.456-1.456a.75.75 0 0 1 1.5 0 2.956 2.956 0 0 1-2.956 2.956h-.294a3.25 3.25 0 0 1-.297-6.487l-.233-.233a.75.75 0 0 1 0-1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.149 5.472a2.75 2.75 0 0 1 2.435-1.472h2.832a2.75 2.75 0 0 1 2.435 1.472l.346.658a.69.69 0 0 0 .612.37c1.21 0 2.191.981 2.191 2.191v4.559a2.75 2.75 0 0 1-2.75 2.75h-8.5a2.75 2.75 0 0 1-2.75-2.75v-4.559c0-1.21.981-2.191 2.191-2.191a.691.691 0 0 0 .612-.37l.346-.658Zm2.435.028c-.465 0-.89.258-1.107.669l-.346.658a2.191 2.191 0 0 1-1.94 1.173.691.691 0 0 0-.691.691v4.559c0 .69.56 1.25 1.25 1.25h8.5c.69 0 1.25-.56 1.25-1.25v-4.559a.691.691 0 0 0-.691-.691 2.191 2.191 0 0 1-1.94-1.173l-.346-.658a1.25 1.25 0 0 0-1.107-.669h-2.832Z"
  }));
};
SvgFlipCameraMajor.displayName = "FlipCameraMajor";

exports.SvgFlipCameraMajor = SvgFlipCameraMajor;
